<template>
  <div>
    <a-spin :spinning="loading">
    <a-form :layout="formLayout" :form="form" style="margin-top:1em;">
      <a-row>
        <a-col :span="12">
          <a-text-field
            varName="billing_details.name"
            varLabel="Full Name"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
          />
        </a-col>
        <a-col :span="12" class="lastfield">
          <a-text-misc-field
            varName="billing_details.email"
            varLabel="Email"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
            varType="email"
          />
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-auto-complete-select
            varName="billing_details.address.country"
            varLabel="Country"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
            :data="dataSource"
          />
        </a-col>
        <a-col :span="12" class="lastfield">
          <a-text-field
            varName="billing_details.address.city"
            varLabel="City, Suburb, Town, or Village"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
          />
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-text-field
            varName="billing_details.address.line1"
            varLabel="Address Line 1"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
          />
        </a-col>
        <a-col :span="12" class="lastfield">
          <a-text-field
            varName="billing_details.address.line2"
            varLabel="Address Line 2"
            :varRequired="false"
            :formLayout="formLayout"
            :size="size"
          />
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-text-field
            varName="billing_details.address.state"
            varLabel="State"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
          />
        </a-col>
        <a-col :span="12" class="lastfield">
          <a-text-field
            varName="billing_details.address.postal_code"
            varLabel="ZIP or Postal Code"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
          />
        </a-col>
      </a-row>
      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <div ref="card" style="width:100% !important;"></div>
      </a-form-item>
      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <a-button type="primary" shape="round" size="large" @click="handleSubmit">{{btnText}}</a-button>
      </a-form-item>
      <a-alert v-if="error_text" :message="error_text" type="error" @close="onErrorClose" closable />
    </a-form>
    </a-spin>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { formLayoutMixin } from "@/mixins/formLayout";
import Countries from "@/data/countries.json";
import _ from "lodash";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

/* global Stripe */
let stripe = Stripe(`${process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY}`),
  elements = stripe.elements({
    fonts: [
      {
        cssSrc: "https://fonts.googleapis.com/css?family=Nunito+Sans"
      }
    ]
  }),
  card = undefined;

let style = {
  base: {
    iconColor: "#002e66",
    fontWeight: 400,
    fontFamily: "Nunito Sans",
    fontSize: "16px",
    color: "rgba(0, 0, 0, .65)",
    ":-webkit-autofill": {
      color: "#fce883"
    },
    '::placeholder': {
      color: '#BFBFBF',
    },
  },
  invalid: {
    iconColor: "#ffa39e",
    color: "#ffa39e"
  }
};

export default {
  data() {
    return {
      hasErrors,
      loading: false,
      size: "large",
      formLayout: "vertical",
      form: this.$form.createForm(this),
      error: false,
      dataSource: _.map(Countries, "Name"),
      error_text: ""
    };
  },

  mixins: [formLayoutMixin],

  mounted: function() {
    card = elements.create("card", {
      iconStyle: "solid",
      hidePostalCode: true,
      style
    });
    card.mount(this.$refs.card);
  },
  beforeDestroy() {
    card.destroy(this.$refs.card);
  },
  computed: {
    ...mapGetters("core", ['customer_id', 'subscription_id']),
  
    hasNoErrors() {
      console.log(this.form.isFieldTouched("billing_details.name"));
      return !this.hasErrors(this.form.getFieldsError());
    }
  },
  methods: {
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          values.billing_details.address.country = Countries.find(
            x => x.Name === values.billing_details.address.country
          ).Code;
          try {
            this.loading = true;
            const result = await stripe.createPaymentMethod({
              type: "card",
              card: card,
              billing_details: values.billing_details
            });
            if (result.error) {
              // Inform the user if there was an error.
              this.error_text =result.error.message;
              throw new TypeError(result.error);
            }
            let payment_method_id = result.id;
            console.log(payment_method_id);
            // Call backend API here
            var subscription = await this.$store.dispatch("core/createItem", {
              endpoint: `tenants/${this.$auth.session.org}/subscription`,
              data: result
            });
            this.$emit('subscriptionData', subscription);
            this.loading = false;
          } catch (error) {
            console.error(error);
            this.loading = false;
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    },
    onErrorClose() {
      this.error_text = ""
    }
  },
  props: {
    btnText: {
      type: String,
      default: "Add Payment Method"
    }
  }
};
</script>

<style lang="css">
.StripeElement {
  box-sizing: border-box;
  max-width: 100%;
  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  border: 1px solid rgb(211, 212, 214);
  border-radius: 5px;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.payment {
  margin-top: 5px;
}

.lastfield {
  padding-left: 5px;
}

.payment-form {
  font-family: "Comfortaa";
}

.ant-slider-handle {
  background-color: #f6ffed;
  border: solid 2px green;
}
.ant-slider-track {
  background-color: green !important;
}
</style>
